import { ViewConfig } from '@spartacus/storefront';

export const SIKO_PLP_VIEW_CONFIG: ViewConfig = {
    view: {
        defaultPageSize: 36,
    },
};
